import React from 'react';

import { Container } from './styles';

const Stack: React.FC = ({ children }) => {
  return (
    <Container>
      <>{children}</>
    </Container>
  );
};

export default Stack;
